// emailValidation.js
const isValidEmail = (email) => {
    // eslint-disable-next-line
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return emailRegex.test(email);
};

function ValidateLoginEmail(email) {
    if (email == null || email === '' || email.length < 10 || email.length > 50) {
        return {
            emailErr: true,
            emailErrMessage: 'Email length should be 10-50 characters',
        };
    } else if (!isValidEmail(email)) {
        return {
            emailErr: true,
            emailErrMessage: 'Invalid Email',
        };
    } else {
        return {
            emailErr: false,
            emailErrMessage: '',
        };
    }
}

export default ValidateLoginEmail;
